/* bundle-stamp.js
   Stamps properties[bundle_group] on multi-item /cart/add requests (e.g., bundles).
   Works for JSON and URL-encoded payloads. Safe no-op for single-item adds.
*/
(function(){
  const origFetch = window.fetch;

  function newGuid(){
    return 'BG' + Date.now().toString(36) + Math.random().toString(36).slice(2,8);
  }
  function getParentTitle(){
    const el = document.querySelector('[data-product-title], h1.product__title, h1');
    return (el && el.textContent || 'Bundle').trim();
  }
  function stampItemsArray(obj){
    if (!obj || !Array.isArray(obj.items)) return false;
    if (obj.items.length < 2) return false; // treat 2+ items as a bundle
    const guid = newGuid();
    const parent = getParentTitle();
    obj.items.forEach((it)=>{
      it.properties = it.properties || {};
      if (!it.properties.bundle_group) it.properties.bundle_group = guid;
      if (!it.properties.bundle_parent_title) it.properties.bundle_parent_title = parent;
      if (!it.properties.bundle_role) it.properties.bundle_role = 'component';
    });
    return true;
  }
  function stampUrlEncoded(bodyStr){
    const params = new URLSearchParams(bodyStr);
    const indices = new Set();
    for (const [k,v] of params){
      const m = k.match(/^items\[(\d+)\]\[/);
      if (m) indices.add(m[1]);
    }
    if (indices.size < 2) return bodyStr; // not a bundle
    const guid = newGuid();
    const parent = getParentTitle();
    indices.forEach(i=>{
      params.set(`items[${i}][properties][bundle_group]`, guid);
      params.set(`items[${i}][properties][bundle_parent_title]`, parent);
      params.set(`items[${i}][properties][bundle_role]`, 'component');
    });
    return params.toString();
  }

  window.fetch = async function(input, init){
    try{
      const url = (typeof input === 'string' ? input : input.url) || '';
      if (url.includes('/cart/add')) {
        if (init && typeof init.body === 'string') {
          const hdrs = init.headers || {};
          const ct = (hdrs['Content-Type'] || hdrs['content-type'] || '').toString();
          if (ct.includes('application/json')) {
            try {
              const obj = JSON.parse(init.body);
              if (stampItemsArray(obj)) init.body = JSON.stringify(obj);
            } catch(e) {}
          } else {
            // URL-encoded form (items[0]…)
            init.body = stampUrlEncoded(init.body);
          }
        }
      }
    } catch(e) {
      // silent no-op
    }
    return origFetch(input, init);
  };
})();
